import schema from './__generated__/schema.possibleTypes.json';
export const possibleTypes: typeof schema['possibleTypes'] = schema.possibleTypes;
